import { ApartmentStats } from "@/models/responses";

// Selects an apartment's per-period breakdown by apartmentId. The backend returns
// these groups in nondeterministic (map-iteration) order, so they MUST be matched
// by id — never by array position — to stay aligned with the id-matched header stats.
export function findPeriodStatsForApartment(periodBreakdownStats: ApartmentStats[][], apartmentId: number): ApartmentStats[] {
    return periodBreakdownStats.find((group) => group.some((stat) => stat.apartmentId === apartmentId)) ?? [];
}
